import React, { useState } from "react";
import styles from "./UnitDetails.module.css";
import UnitSidebar from "./UnitsSidebar";
import UnitHeader from "./UnitHeader";
import UnitOverview from "./UnitOverview";
import UnitAmenities from "./UnitAmenities";
import UnitImages from "./UnitImages";
import UnitTour from "./UnitTour";
import UnitLease from "./UnitLease";
import UnitRoommates from './UnitRoommates';


const UnitDetails = ({ unit, onReturn }) => {
  const [activeTab, setActiveTab] = useState("overview");

  const renderMainContent = () => {
    switch (activeTab) {
      case "overview":
        return <UnitOverview unit={unit} />;
      case 'roommates':
        return <UnitRoommates roommates={unit.roommates} />;
      case "amenities":
        return <UnitAmenities features={unit.Features} />;
      case "images":
        return <UnitImages images={unit.ImageGallery} />;
      case "tour":
        return <UnitTour unit={unit} />;
      case "lease":
        return <UnitLease unit={unit} />;
      default:
        return <UnitOverview unit={unit} />;
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <button className={styles.closeBtn} onClick={onReturn}>✖</button>

        <div className={styles.sidebarContainer}>
          <UnitHeader unit={unit} />
          <UnitSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>

        <div className={styles.mainContent}>
          {renderMainContent()}
        </div>
      </div>
    </div>
  );
};

export default UnitDetails;
